import * as React from 'react';
import { Button, Typography } from '@material-ui/core';
import styled from 'styled-components';
import { SwitchHorizontal01 } from '@untitled-ui/icons-react';
import { Translate } from '@deltasierra/components';
import { LeftNavigationView } from '../enums';

const StyledButton = styled(Button).attrs({ size: 'small', variant: 'outlined' })<{
    $isOpenDrawer: boolean;
    $topOffsetBanner: string;
}>`
    border-color: ${({ theme }) => theme.palette.primary.main};
    color: ${({ theme }) => theme.palette.primary.main};
    height: 34px;
    justify-content: flex-start;
    padding: 4px 16px 4px ${({ $isOpenDrawer }) => ($isOpenDrawer ? '21px' : '25px')};
    // eslint-disable-next-line max-len
    margin: ${({ $isOpenDrawer, $topOffsetBanner }) =>
        $isOpenDrawer ? ` ${$topOffsetBanner} 6px 8px 6px` : `${$topOffsetBanner} 2px 8px 2px`};
    &:hover {
        background-color: ${({ theme }) => theme.palette.contextBackgrounds.primary};
    }
`;

const StyledTypography = styled(Typography)`
    margin: 0 0 0 22px;
    font-size: 13px;
    line-height: 1;
    font-weight: 400;
    letter-spacing: 0.4px;
    text-wrap: nowrap;
`;

export type LeftNavigationViewSwitchProps = {
    currentView: LeftNavigationView;
    isOpenDrawer: boolean;
    topOffsetBanner: string;
    onToggleView: (view: LeftNavigationView) => void;
};

export function LeftNavigationViewSwitch({
    currentView,
    isOpenDrawer,
    onToggleView,
    topOffsetBanner,
}: LeftNavigationViewSwitchProps): JSX.Element {
    const handleButtonClick = React.useCallback(() => {
        const toggledView =
            currentView === LeftNavigationView.brand ? LeftNavigationView.location : LeftNavigationView.brand;
        onToggleView(toggledView);
    }, [currentView, onToggleView]);

    return (
        <StyledButton
            $isOpenDrawer={isOpenDrawer}
            $topOffsetBanner={topOffsetBanner}
            data-cy="left-navigation-view-switch-toggle-button"
            onClick={handleButtonClick}
        >
            <SwitchHorizontal01 />
            {isOpenDrawer && (
                <StyledTypography>
                    {currentView === LeftNavigationView.brand ? (
                        <Translate keyId="MENU.LOCATION" />
                    ) : (
                        <Translate keyId="MENU.BRAND" />
                    )}
                </StyledTypography>
            )}
        </StyledButton>
    );
}

LeftNavigationViewSwitch.displayName = 'LeftNavigationViewSwitch';
